<div data-automation="ziro-directory-number-agent-extension-form">
  <ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.uccx.header'">
    <ziro-checkbox [isAgentExtension]="true" [fieldId]="'agentExtension'"></ziro-checkbox>
  </ziro-fieldset-header>
</div>
